import { useTranslation } from 'react-i18next';
import { Link, NavLink, useLocation } from 'react-router';
import { useState, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { BrandLogo } from 'src/components/brand-logo';
import { mergeClasses } from 'src/utils/merge-classes';
import { useWindowScrolled } from 'src/hooks/use-window-scrolled';

import { ServicesMenu } from './services-menu';

export function SiteHeader() {
  const { t } = useTranslation('navigation');
  const { t: tCommon } = useTranslation('common');
  const { pathname } = useLocation();
  const scrolled = useWindowScrolled();

  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [visitedPath, setVisitedPath] = useState(pathname);

  if (visitedPath !== pathname) {
    setVisitedPath(pathname);
    setMenuOpen(false);
    setServicesOpen(false);
  }

  const handleMenuToggle = useCallback(() => {
    setMenuOpen((previous) => !previous);
  }, []);

  const handleServicesToggle = useCallback(() => {
    setServicesOpen((previous) => !previous);
  }, []);

  const handleServicesClose = useCallback(() => {
    setServicesOpen(false);
  }, []);

  return (
    <header className={mergeClasses('site-header', scrolled && 'scrolled')}>
      <nav className="nav" aria-label={t('ariaLabel')}>
        <Link to={paths.home} className="brand" aria-label={tCommon('brand.homeAriaLabel')}>
          <BrandLogo />
        </Link>
        <button
          type="button"
          className="nav-toggle"
          aria-expanded={menuOpen}
          aria-label={t('openMenu')}
          onClick={handleMenuToggle}
        >
          <span />
          <span />
          <span />
        </button>
        <ul className={mergeClasses('nav-links', menuOpen && 'open')}>
          <li>
            <NavLink end to={paths.home}>
              {t('home')}
            </NavLink>
          </li>
          <ServicesMenu
            open={servicesOpen}
            onClose={handleServicesClose}
            onToggle={handleServicesToggle}
          />
          <li>
            <NavLink to={paths.about}>{t('about')}</NavLink>
          </li>
          <li className="nav-cta">
            <Link to={paths.contact} className="btn btn-blue">
              {tCommon('actions.talk')}
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}
